module.exports = __webpack_public_path__ + "img/cook-islands.5389188d.svg";